/*
 * Submission title component
 */
import React from "react";

import TextField from './text_field.jsx';

export default class AdaliaMESubmissionTitle extends TextField {
  static disallowMultiple() {
    return true;
  }

  static get TYPE() {
    return "adalia_me_submission_title";
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: "component_title_adalia_me_submission_title",
      placeholder: "field_default_placeholder",
      description: "field_default_description",
      help: null,
      unit: null,
    };
  }

  renderPrettyView() {
    const { hide = false, show_label = false } = this.props.content.prettyView || {};
    return (
      (!this.props.content.containsSensitiveInformation && !hide) ? 
      <>
        {show_label &&
        <label>
            <span className="field-label">{this.getText('label')}</span>
        </label>
        }
        <h1 className="field-label">{this.getRawAnswer()}</h1>
      </> : null
    )
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      name: "submission_title",
      required: true,
      cloneable: false,
      reportKey: "Submission title",
    });
  }
}
